import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/base/components/base.component';
import { BottomSheetComponent } from 'src/app/modules/projeto-completo/consulta-geral/bottom-sheet/bottom-sheet.component';

@Component({
  selector: 'app-projeto-layout',
  templateUrl: './projeto-layout.component.html',
  styleUrls: ['./projeto-layout.component.scss']
})
export class ProjetoLayoutComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {

  id: number;
  menu: any[];
  infoProjeto: any;
  pathRoute: string;
  menuActive: boolean;

  @ViewChild('menuDesktop') menuDesktop: ElementRef;
  @ViewChild('menuMobile') menuMobile: ElementRef;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private _bottomSheet: MatBottomSheet,
  ) {
    super()
  }

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.params?.id;
    this.infoProjeto = this.activatedRoute.snapshot.data['infoProjeto'];
    this.initMenu();
  }

  ngAfterViewInit(): void {
    this.verificarOverflow();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initMenu(path = null) {
    this.pathRoute = path ? path : "/pre-projeto/projeto/" + this.id + "/";
    this.menu = this.infoProjeto?.menu;
  }

  isActive(route: string): boolean {
    return this.router.routerState.snapshot.url.includes(route);
  }

  openBottomSheet(): void {
    this._bottomSheet.open(BottomSheetComponent, { data: { pathRoute: this.pathRoute, menu: this.menu, type: 'projeto' } });
  }

  verificarOverflow(): void {
    const menuDesktop = this.menuDesktop.nativeElement;
    const menuMobile = this.menuMobile.nativeElement;
    if (menuDesktop.offsetHeight > 70) {
      menuDesktop.classList.add('menu-desktop-none');
      menuMobile.classList.add('menu-mobile-active');
    } else {
      menuMobile.classList.remove('menu-mobile-active');
      menuDesktop.classList.remove('menu-desktop-none');
    }
  }
}